import { render, staticRenderFns } from "./registro_edicion_FormatoConvenio.vue?vue&type=template&id=1b3a7a7e&scoped=true"
import script from "./registro_edicion_FormatoConvenio.vue?vue&type=script&lang=js"
export * from "./registro_edicion_FormatoConvenio.vue?vue&type=script&lang=js"
import style0 from "./registro_edicion_FormatoConvenio.vue?vue&type=style&index=0&id=1b3a7a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3a7a7e",
  null
  
)

export default component.exports